import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { setStoredAuth, clearStoredAuth, getStoredUser } from '../api/client';
import { loginApi, meApi, logoutApi } from '../api/auth';

const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredUser());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async ({ email, password, remember }) => {
    setLoading(true);
    setError(null);
    try {
      const data = await loginApi({ email, password, remember });
      if (data?.status !== 'success' || !data?.token) throw new Error(data?.message || 'Login failed');
      setStoredAuth(data.token, data.user, remember);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const message = e?.response?.data?.message || 'Invalid email or password';
      setError(message);
      return { ok: false, message };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try { await logoutApi(); } catch (_) {}
    clearStoredAuth();
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const data = await meApi();
      if (data?.user) setUser(data.user);
      return data?.user || null;
    } catch (_) {
      return null;
    }
  };

  const value = useMemo(() => ({ user, loading, error, login, logout, setError, refreshUser }), [user, loading, error]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};


